// extracted by mini-css-extract-plugin
module.exports = {"table-action":"MyConnections_table-action__3xsUA","no-wrap--text":"MyConnections_no-wrap--text__14r6c","connection--delete":"MyConnections_connection--delete__2rbaR"};